export default {
	inserted: function (el) {
		return true
	}
}
